import { useEffect, useState } from "react";
import { useNavigate, useLocation, useParams, Outlet, Link } from "react-router-dom";
import { Menu, ConfigProvider, Dropdown, Space, Button, message } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import api from "@/api";
import { findDeep, getProductManageDetail, format } from "@/utils";
import { publicPath } from "@/utils/base";

import dataJson from "@/../public/data.json";

const prefix = "productDetail";
import "./index.less";
import { cloneDeep } from "lodash-es";

function ProductDetail() {
  const { add, product_detail, release, req_err } = dataJson;
  const [current, setCurrent] = useState("");
  const [dropdownItems, setDropdownItems] = useState<any[]>([]);
  const [dropdownList, setDropdownList] = useState([]);
  const [dropdownCur, setDropdownCur] = useState("");
  const [dropdownSelect, setDropdownSelect] = useState("");
  const [isAddVersion, setIsAddVersion] = useState<boolean>(true);
  const [isTampered, setIsTampered] = useState(false);

  const productManageDetail = useSelector((state: any) => state.productManageDetail);

  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const { id } = useParams();

  const onClick = (e: any) => {
    if (current === e.key) {
      return;
    }
    setCurrent(e.key);
    const targetId =
      e.key === "versionmanage"
        ? productManageDetail?.histories?.[0]?.id || id
        : productManageDetail?.id || id;
    navigate(`${publicPath}${e.item.props.url}/${targetId}`);
  };

  const dropdownOnClick = (e: any) => {
    setDropdownSelect(e.key);
    navigate(`${publicPath}/product_detail/physicalmodel/${e.key}`);
  };

  const upgrade = async () => {
    const firstShowMode = findDeep(release.show_mode_arr, productManageDetail?.histories[0]?.showMode);
    if (productManageDetail?.histories?.length > 1 && firstShowMode.isUpgrade) {
      navigate(`${publicPath}/product_detail/physicalmodel/${productManageDetail?.histories[0].id}`);
    } else {
      try {
        const res: any = await api.atomicUpgrade({ id: productManageDetail?.currentId });
        if (res?.code == 200) {
          navigate(`${publicPath}/product_detail/versionmanage/${res.data.id}`);
          getProductManageDetail(res.data.id, undefined, () => {
            setIsTampered(true);
            navigate(-1);
          });
        } else {
          message.error(res.msg);
        }
      } catch (errorInfo: any) {
        message.error(errorInfo?.response?.data?.msg || req_err);
        return;
      }
    }
  };

  const to = (id: string, cur = current) => {
    switch (cur) {
      case "info":
        navigate(`${publicPath}/product_detail/info/${id}`);
        break;
      case "physical_model":
        navigate(`${publicPath}/product_detail/physical_model/${id}`);
        break;
      case "device_plugin":
        navigate(`${publicPath}/product_detail/device_plugin/${id}`);
        break;
      default:
        null;
    }
  };

  const getDropdownList = async () => {
    try {
      const res: any = await api.getProductManageNoPage({});
      if (res.code === 200) {
        const dataCopy = cloneDeep(res.data);
        const list = dataCopy.map((item: any) => {
          return {
            key: item.id,
            name: item.name,
            label: <a onClick={() => to(item.id)}>{item.name}</a>,
          };
        });
        setDropdownList(list || []);
        const cur = dataCopy?.find((item: any) => item.id === id);
        setDropdownCur(cur?.name || "");
      } else {
        message.error(res.msg || req_err);
      }
    } catch (errorInfo: any) {
      console.error(errorInfo);
    }
  };

  useEffect(() => {
    if (productManageDetail) {
      const resData = cloneDeep(productManageDetail);
      const resShowMode = findDeep(release.show_mode_arr, resData?.showMode);
      // const firstShowMode = findDeep(release.show_mode_arr, productManageDetail?.histories[0]?.showMode);
      // 有升级场景，在新版本页面，按钮要受到旧版本状态影响
      if (resShowMode?.isUpgrade && resData?.histories?.length > 1) {
        const oldShowMode = resData?.histories[1]?.showMode;
        resData.baseBtns = resShowMode?.btnsByOld[oldShowMode];
      } else {
        resData.baseBtns = resShowMode?.baseBtns;
      }
      // if (resData?.showMode === "HISTORY" || (firstShowMode?.isUpgrade && resData.id !== firstShowMode?.id)) {
      //   setIsAddVersion(false);
      // } else {
      setIsAddVersion(!resData.baseBtns?.includes("upgrade"));
      // }

      getDropdownList();

      const newDropdownItems: any[] = productManageDetail?.histories?.map((item: any) => {
        const showModeItem = findDeep(release.show_mode_arr, item?.showMode);
        return {
          key: item.id,
          label: (
            <div className={`${prefix}-dropdownItems`}>
              <div className={`${prefix}-dropdownItems-version one-line-ellipsis`} title={item.version}>
                {item?.version ? (
                  <div className={`${prefix}-dropdownItems-version-text`}>
                    {product_detail.version_v}
                    {item.version}
                  </div>
                ) : (
                  <div className={`${prefix}-dropdownItems-version-text`}>{product_detail.new_version}</div>
                )}
                <div className={`${prefix}-dropdownItems-version-status`} style={{ color: showModeItem.textColor }}>
                  {showModeItem.title}
                </div>
              </div>
              <div className={`${prefix}-dropdownItems-time`}>
                {format(new Date(Number(item.createTime)), "yy年MM月dd日 HH:mm")}
              </div>
            </div>
          ),
        };
      });
      setDropdownItems(newDropdownItems || []);
    }
  }, [productManageDetail]);

  useEffect(() => {
    const pathArr = pathname.split("/");
    setCurrent(pathArr[pathArr.length - 2]);
    setDropdownSelect(id || "");
  }, [pathname]);

  useEffect(() => {
    setIsTampered(false);
    getProductManageDetail(id, undefined, () => {
      setIsTampered(true);
      navigate(-1);
    });
  }, [id]);
  return (
    <div className={prefix}>
      <div className={`${prefix}-menu-wrap`}>
        <ConfigProvider
          theme={{
            components: {
              Menu: {
                itemSelectedBg: "#0A59F7",
                itemSelectedColor: "#fff",
                itemBorderRadius: 0,
                iconSize: 14,
                itemHeight: 64,
                fontSize: 18,
              },
            },
          }}
        >
          <Menu
            onClick={onClick}
            mode="inline"
            items={product_detail.menu}
            selectedKeys={[current]}
            className={`${prefix}-menu`}
          />
        </ConfigProvider>
      </div>
      <ConfigProvider
        theme={{
          components: {
            Button: { colorPrimary: "#0A59F7" },
            Tabs: { colorPrimary: "#0A59F7" },
          },
        }}
      >
        <div className={`${prefix}-top`}>
          <div className={`${prefix}-breadCrumb`}>
            <Link to={`${publicPath}/staging`} state={{ tabKey: "4" }} className={`${prefix}-breadCrumb-link`}>
              {product_detail.product}
            </Link>
            &nbsp;/&nbsp;
            <Link to={`${publicPath}/product_manage`} className={`${prefix}-breadCrumb-link`}>
              {product_detail.product_manage_text}
            </Link>
            &nbsp;/&nbsp;
            <Dropdown menu={{ items: dropdownList, style: { maxHeight: "70vh" } }}>
              <Space style={{ color: "#1A1A1A" }}>
                {productManageDetail?.histories?.[0]?.name || dropdownCur || "--"}
                <DownOutlined />
              </Space>
            </Dropdown>
          </div>
          {current === "versionmanage" ? (
            <div className={`${prefix}-top-right`}>
              <Button type="link" disabled={isTampered || isAddVersion} onClick={upgrade}>
                {add + product_detail.version}
              </Button>
              <Dropdown
                menu={{
                  items: dropdownItems,
                  selectable: true,
                  selectedKeys: [dropdownSelect],
                  onClick: dropdownOnClick,
                }}
                overlayClassName={`${prefix}-dropdown-overlay`}
              >
                <span className={`${prefix}-dropdown`}>
                  <Space>
                    {product_detail.version}
                    <DownOutlined />
                  </Space>
                </span>
              </Dropdown>
            </div>
          ) : (
            <span></span>
          )}
        </div>

        <Outlet context={{ isTampered, setIsTampered }} />
      </ConfigProvider>
    </div>
  );
}

export default ProductDetail;
